import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/novelPostlink/getList',
        method: 'get',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/novelPostlink/details',
        method: 'get',
        params: query
    })
}
// 添加
export function add(query) {
    return axios({
        url: '/novelPostlink/addInfo',
        method: 'post',
        data: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/novelPostlink/delete',
        method: 'get',
        params: query
    })
}
//禁用
export function disable(query) {
    return axios({
        url: '/video/postlink/disable',
        method: 'get',
        params: query
    })
}
// 获取检测链接
export function monitoringLink(query) {
    return axios({
        url: '/novelPostlink/getMonitoringLink',
        method: 'get',
        params: query
    })
}
// 自定义广告计划
export function addPost(query, data) {
    return axios({
        url: '/novelPostlink/addNovelLinkCustomizePost',
        method: 'post',
        params: query,
        data: data
    })
}
// 组件列表
export function detailsPost(query) {
    return axios({
        url: '/novelPostlink/getNovelLinkCustomizePostByTfId',
        method: 'get',
        params: query
    })
}
// 组件列表
export function allAdId(query) {
    return axios({
        url: '/novelPostlink/getAdId',
        method: 'get',
        params: query
    })
}
